import { Component, computed, ElementRef, ViewChild } from '@angular/core';
import { RouterModule } from '@angular/router';
import { LayoutService } from '../../service/layout.service';
import { ImageModule } from 'primeng/image';
import { CommonModule } from '@angular/common';
import { SuperAdminAppMenu } from './super-admin.menu';
@Component({
    selector: '[app-super-admin-sidebar]',
    standalone: true,
    imports: [SuperAdminAppMenu, RouterModule, ImageModule, CommonModule],
    templateUrl: 'super-admin-sidebar.html',
})
export class SuperAdminSideBar {
    timeout: any = null;
    public imgSrcComputed = computed(() => {
        const state = this.layoutService.layoutState();
        
        const isReveal = this.layoutService.isReveal();
        const isSlim = this.layoutService.isSlim();
        const isSlimPlus = this.layoutService.isSlimPlus();
        const isHorizontal = this.layoutService.isHorizontal();

        if (isReveal) {
            const isExpanded = state.sidebarActive || state.anchored;
            return isExpanded 
                ? '/layout/images/clubside-logo-1.svg' 
                : '/layout/images/clubside-logo-small.svg';
        }

        if (isSlim || isSlimPlus || isHorizontal) {
            return '/layout/images/clubside-logo-small.svg';
        }

        return '/layout/images/clubside-logo-1.svg';
    });

    public showSmallImageComputed = computed(() => {
        const state = this.layoutService.layoutState();
        const isReveal = this.layoutService.isReveal();
        const isSlim = this.layoutService.isSlim();
        const isSlimPlus = this.layoutService.isSlimPlus();
        const isHorizontal = this.layoutService.isHorizontal();

        if (isReveal) {
            const isExpanded = state.sidebarActive || state.anchored;
            return !isExpanded; // Returns TRUE (Small) if NOT expanded
        }

        return isSlim || isSlimPlus || isHorizontal;
    });

    @ViewChild('menuContainer') menuContainer!: ElementRef;
    constructor(
        public layoutService: LayoutService,
        public el: ElementRef,
    ) {}

    onMouseEnter() {
        if (!this.layoutService.layoutState().anchored) {
            if (this.timeout) {
                clearTimeout(this.timeout);
                this.timeout = null;
            }

            this.layoutService.layoutState.update((state) => {
                if (!state.sidebarActive) {
                    return {
                        ...state,
                        sidebarActive: true,
                    };
                }
                return state;
            });
        }
    }

    onMouseLeave() {
        if (!this.layoutService.layoutState().anchored) {
            if (!this.timeout) {
                this.timeout = setTimeout(() => {
                    this.layoutService.layoutState.update((state) => {
                        if (state.sidebarActive) {
                            return {
                                ...state,
                                sidebarActive: false,
                            };
                        }
                        return state;
                    });
                }, 300);
            }
        }
    }

    anchor() {
        this.layoutService.layoutState.update((state) => ({
            ...state,
            anchored: !state.anchored,
        }));
    }
}
